import {fail, finish, start} from "@/utils/Progress";
import {entityUuidFromLocation} from "@/utils/EntityUuid";
import store from "@/store";
import {mapActions} from "vuex";

const BeforeRoute = (fetchAction, additionalParams) => {
  return {
    beforeRouteEnter(to, from, next) {
      start();

      const storageKey = 'ls-member-module-' + entityUuidFromLocation();
      const state = JSON.parse(localStorage.getItem(storageKey));

      if (!state) {
        fail();
        next(vm => {
          vm.$router.push({name: 'LoginPage'})
        });
        return;
      }

      store.dispatch(fetchAction, {
        headers: {
          Authorization: `Bearer ${state.auth.token}`
        },
        route: to,
        ...additionalParams,
      })
        .then(() => {
          next();
          finish();
        })
        .catch(() => {
          fail();
          next(vm => {
            vm.pushToFirstAvailablePage()
          });
        });
    },
    beforeRouteUpdate(to, from, next) {
      start();

      store.dispatch(fetchAction)
        .then(() => {
          next();
          finish();
        })
        .catch(() => {
          fail();

          this.pushToFirstAvailablePage();

          next();
        });
    },
    methods: {
      ...mapActions([
        'pushToFirstAvailablePage'
      ])
    }
  }
};

export default BeforeRoute;
